export const check = (value, validators) => (
  Object.keys(validators)
    .filter(key => !validators[key](value))
);

export default (value, validators, errorLabels) => (
  check(value, validators).map(key => errorLabels[key])
);
